import { useParams, useOutletContext, Link } from "react-router-dom";
import { useEffect, useState } from "react";

import "./GaleryById.css";
import {translations} from './../../i18/translations.js';

const GaleryById = () => {
    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const RESOURCES_DIR = process.env.REACT_APP_RESOURCES_DIR;
    const {lang} = useOutletContext();
    const {id} = useParams();
    const [gallery, setGallery] = useState({images: []});
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);

    useEffect(() => {
        const fetchGallery = async () => {
            try {
                const response = await fetch(`${API_URL}/common/get_galery.php`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({id})
                });
                const data = await response.json();
                setGallery(data);
            } catch (error) {
                console.error("Error fetching gallery:", error);
            }
        };
        fetchGallery();
    }, [id, lang]);

    const openOverlay = (index) => {
        setSelectedImageIndex(index);
    };

    const closeOverlay = () => {
        setSelectedImageIndex(null);
    };

    const showPrevImage = (e) => {
        e.stopPropagation();
        setSelectedImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : gallery.images.length - 1));
    };

    const showNextImage = (e) => {
        e.stopPropagation();
        setSelectedImageIndex((prevIndex) => (prevIndex < gallery.images.length - 1 ? prevIndex + 1 : 0));
    };

    return (
            <div>
                <Link className="content-view-link galery-link" to="/GaleryList">{translations[lang].back}</Link>
                <h1 className="mbkegy-content">{gallery.name}</h1>
                <div className="galery-container">
                    {gallery.images.map((image, index) => (
                                <img
                                    key={index}
                                    src={`${RESOURCES_DIR}/galery/${image.base_dir}/${image.index_dir}/${image.index_file_name}`}
                                    className="index-img"
                                    onClick={() => openOverlay(index)}
                                    alt=""
                                    />
                                    ))}
            
                    {selectedImageIndex !== null && (
                            <div className="overlay" onClick={closeOverlay}>
                                <span className="counter">
                                    {selectedImageIndex + 1} / {gallery.images.length}
                                </span>
                                <span className="close" onClick={closeOverlay}>&times;</span>
                                <img
                                    className="overlay-img"
                                    src={`${RESOURCES_DIR}/galery/${gallery.images[selectedImageIndex].base_dir}/${gallery.images[selectedImageIndex].show_dir}/${gallery.images[selectedImageIndex].index_file_name}`}
                                    alt=""
                                    />
                                <span className="prev" onClick={showPrevImage}>&#10094;</span>
                                <span className="next" onClick={showNextImage}>&#10095;</span>
                            </div>
                                )}
            
                    {gallery.content !== null && (
                            <div className="mbkegy-content" dangerouslySetInnerHTML={{__html: gallery.content}} />
                                )}
                </div>
            </div>
            );
};

export default GaleryById;
